import { ReactNode } from 'react';

import { usePanelBehavior } from '~/shared/utils/usePanelBehavior';

interface SidePanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  width?: string;
  children: ReactNode;
  className?: string;
  enableClickOutside?: boolean;
  enableEscapeKey?: boolean;
  excludeSelectors?: string[];
  onClose?: () => void; // callback to execute when panel closes
}

export default function SidePanel({
  open,
  onOpenChange,
  width = 'w-[587px]',
  children,
  className = '',
  enableClickOutside = true,
  excludeSelectors,
  onClose,
}: SidePanelProps) {
  const { panelRef } = usePanelBehavior(open, onOpenChange, enableClickOutside, excludeSelectors, onClose);

  return (
    <div
      ref={panelRef}
      className={`fixed -mt[0.125px] right-0 z-[20] ${width} bg-white border-l border-primary-70 transform transition-transform duration-300 ease-in-out ${
        open ? 'translate-x-0' : 'translate-x-full'
      } ${className}`}
      style={{
        top: 0,
        bottom: 0,
        boxShadow: '-15px 86px 57.4px -3px rgba(0, 0, 0, 0.09)',
      }}
    >
      {children}
    </div>
  );
}
